import { useAppStore } from '@/modules/apps/store';
import { useAuthStore } from '@/modules/auth/store';
import { ROUTE_NAME_LOGIN } from '@/modules/login/router';
import { ROUTE_NAME_HOMEPAGE } from '@/modules/main/router';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    const appStore = useAppStore();
    const authStore = useAuthStore();

    if ('appId' in to.params && to.params.appId) {
        const urlAppId = Number(to.params.appId);
        if (!isNaN(urlAppId) && urlAppId !== appStore.appId) {
            appStore.setAppId(urlAppId);
        }
    }

    const isAuthenticated = authStore.isAuthenticated;
    if (to.meta.requiresAuth && !isAuthenticated) {
        return next({ name: ROUTE_NAME_LOGIN.INDEX });
    }
    if (to.meta.requiresUnauth && isAuthenticated) {
        return next({ name: ROUTE_NAME_HOMEPAGE });
    }

    next();
});

export default router;
